// removed by extract-text-webpack-plugin
module.exports = {"ButtonProceed":"_2VzJ5","ButtonProceedActive":"_1LzSG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/ButtonProceed/ButtonProceed.scss
// module id = 370
// module chunks = 0